module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "error-page"
  }, [_c('h2', {
    staticClass: "headline text-red"
  }, [_vm._v("401")]), _vm._v(" "), _c('div', {
    staticClass: "error-content"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("\n          Clique "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Homepage'
      },
      "exact": ""
    }
  }, [_c('a', [_c('span', [_vm._v("aqui")])])]), _vm._v(" para continuar da página inicial\n        ")], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('i', {
    staticClass: "fa fa-warning text-red"
  }), _vm._v(" Não autorizado.")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6718c3ab","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/error/UnauthorizedError.vue
// module id = 739
// module chunks = 1